import {
  Component,
  OnInit,
  Inject,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { ActivatedRoute } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { IdMeServices } from "./../services/id-me.services";
import { VolvoApiService } from "../../services/volvo-api.service";
import { MatDialog } from "@angular/material";
import { ModalWrapperComponent } from "../../blocks/modals/components/modal-wrapper/modal-wrapper.component";
import { WindowRef } from "../services/components.util.services";
import { DynamicScriptLoaderService } from "../../services/dynamic-script-loader.service";

@Component({
  selector: "app-id-me",
  templateUrl: "./id-me.component.html",
  styleUrls: ["./id-me.component.scss"],
})
export class IdMeComponent implements OnInit {
  @Input() pageConfig: any;
  @Input() localStrings: any;

  public idMeDataScope: string;
  public idMeDataText: string;
  public idMeDataRedirect: string;
  public promotionAlias: string;
  private idMeData: Observable<any>;

  constructor(
    private route: ActivatedRoute,
    private imService: IdMeServices,
    private volvoApi: VolvoApiService,
    private dialog: MatDialog,
    private cookieService: CookieService,
    private windowRef: WindowRef,
    private dynamicScriptLoader: DynamicScriptLoaderService
  ) {}

  ngOnInit() {
    // try to find the idme code in the cookie
    const idMeCode = this.cookieService.get("idMeCode");
    const idMeInfo = this.cookieService.get("idMeInfo");

    this.promotionAlias = this.route.snapshot.params["promotionAlias"];
    const fiveMinutes = 0.0035;

    const redirectBase = `${
      window.location.protocol
    }//${this.volvoApi.getDomain()}/`;

    this.idMeDataScope = "military";
    this.idMeDataText = "Military members receives discount with ID.me";
    this.idMeDataRedirect = redirectBase + this.promotionAlias;

    const alias = this.pageConfig.Alias.split(";");

    if (alias.includes("firstresponder") || alias.includes("firstresponders")) {
      this.idMeDataScope = "responder";
      this.idMeDataText = "First Responders receive discount with ID.me";
    } else if (alias.includes("teacher") || alias.includes("teachers")) {
      this.idMeDataScope = "teacher";
      this.idMeDataText = "teachers receive discount with ID.me";
    } else if (alias.includes("medical") || alias.includes("healthcare")) {
      this.idMeDataScope = "medical,nurse,hospital_employee";
      this.idMeDataText = "medical employees receive discount with ID.me";
    }

    // load the idme wallet script now that the button element is applied
    this.loadScripts();

    if (idMeCode !== "" && idMeInfo === "") {
      this.idMeData = this.volvoApi.getIdMeUserData(
        this.promotionAlias,
        idMeCode
      );

      this.idMeData.subscribe((r) => {
        // console.log(r);

        // if the idme verification is valid
        if (r.Valid) {
          this.cookieService.set(
            "idMeInfo",
            JSON.stringify(r),
            fiveMinutes,
            null,
            null,
            true,
            "Lax"
          );
          this.openRegModal();
        } else {
          // delete the cookies so that the user
          // must reauthenicate w/ idme
          this.cookieService.delete("idMeInfo");
          this.cookieService.delete("idMeCode");

          let message = this.localStrings[r.ErrorMessage];

          if (message == null) {
            message = r.ErrorMessage;
          }

          throwError(`${r.ErrorMessage}`);

          if (r.ErrorMessage.includes("serviceendednotfound")) {
            const redirectLink = `<a href='https://api.id.me/oauth/authorize?client_id=1168727a565d2cca9a917a3e5ad8f624&redirect_uri=${this.idMeDataRedirect}&response_type=code&scope=enforce_military'>here</a>`;
            message = message.replace("<a href=''>here</a>", redirectLink);
          }

          this.openAlertModal(message);
        }
      });
    } else if (idMeInfo !== "") {
      // delete the code cookies because it is most
      // likely no longer valid
      this.cookieService.delete("idMeCode");
    } else {
      // delete the cookies so that the user
      // must reauthenicate w/ idme
      this.cookieService.delete("idMeInfo");
      this.cookieService.delete("idMeCode");
    }
  }

  openRegModal() {
    const dialogRef = this.dialog.open(ModalWrapperComponent, {
      panelClass: "modal-panel",
      hasBackdrop: false,
      height: "100%",
      width: "100%",
    });
    dialogRef.componentInstance.modalName = "registration";
    dialogRef.componentInstance.Guid = this.pageConfig.Guid;
    dialogRef.componentInstance.CountryID = this.pageConfig.CountryID;
    dialogRef.componentInstance.localStrings = this.localStrings;
    dialogRef.componentInstance.AdditionalFieldsFormID = this.pageConfig.AdditionalFieldsFormID;
    dialogRef.componentInstance.pageConfig = this.pageConfig;
    dialogRef.componentInstance.promotionAlias = this.promotionAlias;
  }

  openAlertModal(message) {
    const dialogRef = this.dialog.open(ModalWrapperComponent, {
      panelClass: "modal-panel",
      hasBackdrop: false,
      height: "100%",
      width: "100%",
    });
    dialogRef.componentInstance.modalName = "alert-message";
    dialogRef.componentInstance.Guid = this.pageConfig.Guid;
    dialogRef.componentInstance.CountryID = this.pageConfig.CountryID;
    dialogRef.componentInstance.localStrings = this.localStrings;
    dialogRef.componentInstance.AdditionalFieldsFormID = this.pageConfig.AdditionalFieldsFormID;
    dialogRef.componentInstance.pageConfig = this.pageConfig;
    dialogRef.componentInstance.message = message;
  }

  loadScripts() {
    this.dynamicScriptLoader
      .load("idmeWallet")
      .then((data) => {
        // Script Loaded Successfully
        // bind the wallet elem to idMe
        this.windowRef.window.BindIDme();
      })
      .catch((error) => console.log(error));
  }
}
